export const externalStudyPermissions = {
  Read: "externalStudyCanRead"
};
